/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountLimits} from '../models/AccountLimits';
import type {Error} from '../models/Error';

export interface GetAccountLimits$Request {
    accountId: number;
}

export interface GetAccountLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountLimitsRequest = createAction<PayloadData<void, GetAccountLimits$Request>>('ACCOUNT_LIMITS__GET_ACCOUNT_LIMITS__REQUEST');
export const getAccountLimitsSuccess = createAction<PayloadData<AccountLimits, GetAccountLimits$Request>>('ACCOUNT_LIMITS__GET_ACCOUNT_LIMITS__SUCCESS');
export const getAccountLimitsFailure = createAction<PayloadData<Error, GetAccountLimits$Request, true>>('ACCOUNT_LIMITS__GET_ACCOUNT_LIMITS__FAILURE');

export const getAccountLimitsActions = [
    getAccountLimitsRequest,
    getAccountLimitsSuccess,
    getAccountLimitsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountLimits = (meta: GetAccountLimits$Request, config?: GetAccountLimits$Config) => {
    return {
        CALL_API: {
            types: getAccountLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveAccountLimits$Request {
    accountId: number;
    accountLimits: AccountLimits;
}

export interface SaveAccountLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveAccountLimitsRequest = createAction<PayloadData<void, SaveAccountLimits$Request>>('ACCOUNT_LIMITS__SAVE_ACCOUNT_LIMITS__REQUEST');
export const saveAccountLimitsSuccess = createAction<PayloadData<void, SaveAccountLimits$Request>>('ACCOUNT_LIMITS__SAVE_ACCOUNT_LIMITS__SUCCESS');
export const saveAccountLimitsFailure = createAction<PayloadData<Error, SaveAccountLimits$Request, true>>('ACCOUNT_LIMITS__SAVE_ACCOUNT_LIMITS__FAILURE');

export const saveAccountLimitsActions = [
    saveAccountLimitsRequest,
    saveAccountLimitsSuccess,
    saveAccountLimitsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {AccountLimits} meta.accountLimits
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveAccountLimits = (meta: SaveAccountLimits$Request, config?: SaveAccountLimits$Config) => {
    return {
        CALL_API: {
            types: saveAccountLimitsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/limits`,
            TRANSPORT_REQUEST_BODY: meta.accountLimits,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

